module.exports = __webpack_public_path__ + "img/us-quotation-popup-pi@2x.40b76e67.png";